import { AccessorsMutatorsDecorator, Model } from '../../helpers';
import { Property } from './property.model';

export class Housekeeper extends Model {
    
    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {
        
        return value instanceof Property ? value : new Property(value);
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'HOUSEKEEPER_NAME'
            },
        };
    }
}

AccessorsMutatorsDecorator('id', 'name', 'property', 'property_id')(Housekeeper);



// WEBPACK FOOTER //
// ./src/pms-api/models/housekeeper.model.js